import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {Views} from '@ccp/config/views';
import {FeatureToggleService} from '@ccp/services/toggle-features/feature-toggle.service';
import {ToggleFeatures} from '@ccp/enums/toggleFeatures.enum';

export const ScanGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const featureToggleService = inject(FeatureToggleService);
  if (!featureToggleService.featureConfig$().getConfig(ToggleFeatures.scanQRCode)) {
    return router.createUrlTree([Views.productRegister.path], {queryParams: route.queryParams});
  }
  return true;
};
